import defaultLayout from "@/layouts/side-nav-outer-toolbar";
import loadView from "../common/loadView";

export default [
  {
    path: "/contract-template/:mode/:id?",
    name: "contract-template",
    meta: {
      requiresAuth: true,
      requiresPermission: true,
      layout: defaultLayout,
      navPermission: "Шаблон договора",
    },
    component: loadView("contract-templates/contract-templates-detail-view"),
  },
  {
    path: "/contract-templates",
    name: "contract-templates",
    meta: {
      requiresAuth: true,
      requiresPermission: true,
      layout: defaultLayout,
      navPermission: "Шаблон договора",
    },
    component: loadView("contract-templates/contract-templates-list-view"),
  },
];
